import { connect } from 'react-redux'
import { setSearchResponse } from 'redux/actions'
import ConnectedMultiPageSearch from 'pages/search/ConnectedMultipageSearch'

const mapStateToProps = state => ({
  flavour: state.layout.flavour,
  aol: state.aol.name,
  searchType: state.search.searchType,
  searchPhrase: state.search.searchPhrase,
  pageNumber: state.search.pageNumber,
  pageLimit: state.search.pageLimit,
  query: state.search.query
})

const mapDispatchToProps = dispatch => ({
  setSearchResponse: response => dispatch(setSearchResponse(response))
})

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedMultiPageSearch)
